import script from "./detailsTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./detailsTop.vue?vue&type=script&lang=ts&setup=true"

import "./detailsTop.vue?vue&type=style&index=0&id=3ff275d8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff275d8"]])

export default __exports__